module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-down-alt-759460c9.svg";